import React from "react";
export default function TotalPrice({ totalPrice }) {
  return totalPrice ? (
    <div id="total-price" className="option_price">
      ${totalPrice}
    </div>
  ) : (
    <div id="total-price" className="option_price"></div>
  );
}
